import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
import { motion } from 'framer-motion';
export function Footer() {
  return <motion.footer initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 1,
    delay: 1.5
  }} className="w-full py-12 px-6 mt-auto relative z-10 border-t border-mocha/50 flex flex-col items-center justify-center text-center" data-id="element-24">
      <p className="font-script text-2xl text-pale mb-6" data-id="element-25">
        In the heart of the neighborhood
      </p>

      <div className="flex gap-6 mb-8" data-id="element-26">
        <a href="#" className="text-cream/60 hover:text-red transition-colors duration-300" aria-label="Instagram" data-id="element-27">
          <Instagram size={24} strokeWidth={1.5} data-id="element-28" />
        </a>
        <a href="#" className="text-cream/60 hover:text-red transition-colors duration-300" aria-label="Facebook" data-id="element-29">
          <Facebook size={24} strokeWidth={1.5} data-id="element-30" />
        </a>
      </div>

      <p className="text-xs font-sans text-cream/40 tracking-wider" data-id="element-31">
        &copy; {new Date().getFullYear()} DEPINGA CAFÉ. ALL RIGHTS RESERVED.
      </p>
    </motion.footer>;
}